import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  fetchError: null,
  groups: [],
  fields: [],
  configs: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.UNIVERSAL_DATA_EXPORT_FETCH_SUCCESS:
      return {
        ...state,
        groups: payload.Groups,
        fields: payload.Fields,
        configs: payload.Configs,
      };
    case types.UNIVERSAL_DATA_EXPORT_FETCHING:
      return {
        ...state,
        fetching: payload,
      };

    case types.UNIVERSAL_DATA_EXPORT_FETCH_ERROR:
      return {
        ...state,
        fetchError: payload,
      };

    case types.UNIVERSAL_DATA_EXPORT_CLEAR_ERRORS:
      return {
        ...state,
        fetchError: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/universaldataexport/state/reducer.js